import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import { graphql, gql, compose } from 'react-apollo';

import Loader from '../../UI/Loader';
import FormTextField from '../../UI/FormTextField';
import Form from '../../UI/Form';
import FormRaisedButton from '../../UI/FormRaisedButton';
import { RaisedButton } from 'material-ui';

const tournamentCriteriaQuery = gql`
    query TournamentCriteriaQuery($tournamentId: ID!) {
        tournament(_id: $tournamentId) {
            _id
            number
            p {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            m {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            t {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            v {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            criteria {
                p {
                    junior
                    senior
                }
                m {
                    junior
                    senior
                }
                t {
                    junior
                    senior
                }
                v {
                    junior
                    senior
                }
            }
        }
    }
`;

const updateTournamentCriteriaMutation = gql`
    mutation UpdateTournamentCriteriaMutation($tournamentId: ID!, $criteria: TournamentCriteriaInput!) {
        updateTournamentCriteria(tournamentId: $tournamentId, criteria: $criteria) {
            _id
            number
            p {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            m {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            t {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            v {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            criteria {
                p {
                    junior
                    senior
                }
                m {
                    junior
                    senior
                }
                t {
                    junior
                    senior
                }
                v {
                    junior
                    senior
                }
            }
        }
    }
`;

const rounds = ['p', 'm', 't', 'v'];

class CriteriaForm extends Component {
    constructor(props) {
        super(props);

        const { criteria } = props;

        this.state = {
            saving: false,
            form: {
                'p.junior': (criteria.p && criteria.p.junior) || '',
                'p.senior': (criteria.p && criteria.p.senior) || '',

                'm.junior': (criteria.m && criteria.m.junior) || '',
                'm.senior': (criteria.m && criteria.m.senior) || '',

                't.junior': (criteria.t && criteria.t.junior) || '',
                't.senior': (criteria.t && criteria.t.senior) || '',

                'v.junior': (criteria.v && criteria.v.junior) || '',
                'v.senior': (criteria.v && criteria.v.senior) || '',
            },
        };
    }

    handleFormValuesUpdate = form => {
        this.setState({ form });
    };

    handleSubmit = form => {
        this.setState({ saving: true });
        this.props.onSave({
            p: {
                junior: form['p.junior'],
                senior: form['p.senior'],
            },
            m: {
                junior: form['m.junior'],
                senior: form['m.senior'],
            },
            t: {
                junior: form['t.junior'],
                senior: form['t.senior'],
            },
            v: {
                junior: form['v.junior'],
                senior: form['v.senior'],
            },
        });
    };

    render() {
        return (
            <Form
                form={this.state.form}
                onFormValuesUpdate={this.handleFormValuesUpdate}
                onSubmit={this.handleSubmit}
                labelIdPrefix="TownsList"
            >
                <h3 style={{ marginBottom: 0 }}>
                    <FormattedMessage id="Report.round.p" />
                </h3>
                <FormTextField fullWidth name="p.junior" />
                <FormTextField fullWidth name="p.senior" />
                <br />
                <br />
                <h3 style={{ marginBottom: 0 }}>
                    <FormattedMessage id="Report.round.m" />
                </h3>
                <FormTextField fullWidth name="m.junior" />
                <FormTextField fullWidth name="m.senior" />
                <br />
                <br />
                <h3 style={{ marginBottom: 0 }}>
                    <FormattedMessage id="Report.round.t" />
                </h3>
                <FormTextField fullWidth name="t.junior" />
                <FormTextField fullWidth name="t.senior" />
                <br />
                <br />
                <h3 style={{ marginBottom: 0 }}>
                    <FormattedMessage id="Report.round.v" />
                </h3>
                <FormTextField fullWidth name="v.junior" />
                <FormTextField fullWidth name="v.senior" />
                <br />
                <br />
                <FormRaisedButton primary action="submit" label="Сохранить" disabled={this.state.saving} />
            </Form>
        );
    }
}

class TournamentCriteria extends Component {
    static propTypes = {};

    state = {
        isEditing: false,
    };

    handleCriteriaUpdate = async newCriteria => {
        await this.props.mutate({ variables: { tournamentId: this.props.data.tournament._id, criteria: newCriteria } });
        await this.props.data.refetch();
        this.setState({ isEditing: false });
    };

    render() {
        const {
            isAdmin,
            data: { loading, tournament },
        } = this.props;

        const { isEditing } = this.state;

        if (loading) {
            return <Loader centerX />;
        }

        if (!isAdmin || !isEditing) {
            return (
                <div>
                    <h2>
                        {tournament.number}
                        -й Турнир — Критерии
                    </h2>
                    {rounds
                        .filter(
                            round =>
                                tournament.criteria &&
                                tournament.criteria[round] &&
                                (tournament.criteria[round].junior || tournament.criteria[round].senior)
                        )
                        .map(round => (
                            <p key={round}>
                                <h3 style={{ marginBottom: 0 }}>
                                    <FormattedMessage id={`Report.round.${round}`} />
                                </h3>
                                {tournament.criteria[round].junior && (
                                    <a href={tournament.criteria[round].junior} target="_blank">
                                        <FormattedMessage id="Report.level.junior" />
                                    </a>
                                )}
                                <br />
                                {tournament.criteria[round].senior && (
                                    <a href={tournament.criteria[round].senior} target="_blank">
                                        <FormattedMessage id="Report.level.senior" />
                                    </a>
                                )}
                                <br />
                                <br />
                            </p>
                        ))}
                    {isAdmin && (
                        <RaisedButton
                            primary={true}
                            label="Редактировать"
                            onClick={() => this.setState({ isEditing: true })}
                        />
                    )}
                </div>
            );
        }

        if (isEditing) {
            return <CriteriaForm criteria={tournament.criteria || {}} onSave={this.handleCriteriaUpdate} />;
        }

        return null;
    }
}

export default compose(
    graphql(tournamentCriteriaQuery, {
        options: ({ tournament }) => ({ variables: { tournamentId: tournament._id }, fetchPolicy: 'no-cache' }),
    }),
    graphql(updateTournamentCriteriaMutation),
    injectIntl
)(TournamentCriteria);



// WEBPACK FOOTER //
// ./src/Components/TournamentCriteria/TournamentCriteria.js